import React from 'react';
import FooterHome from './FooterHome';

function Footer() {
    return (
        <>
            <FooterHome />
        </>

    );
}

export default Footer;